import isNil from "lodash/fp/isNil";

class Controller {
  constructor($injector, $mdDialog, customer, Events) {
    "ngInject";
    this.$mdDialog = $mdDialog;
    this.customer = customer;
    this.Currency = $injector.get("Currency");
    this.City = $injector.get("City");
    this.selected = {};
    this.currency = this.customer.city.currency;
    this.Events = Events;
    this.errorNotificationEvent = this.Events.eventsType.onShowErrorNotification;
  }

  $onInit() {
    this.Currency.getAll({ isCityRequired: false }).$promise.then(
      (response) => {
        this.currencies = response.currencies;
      },
      (response) => this.Events.emit(this.errorNotificationEvent, response.data)
    );
  }
  close() {
    this.$mdDialog.cancel();
  }

  confirm() {
    if (!isNil(this.currency)) {
      this.selected.currency = this.currency;
    }
    this.$mdDialog.hide(this.selected);
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/pages/customer/chargeDialog/chargeDialog.controller.js